import { defineCustomElement } from '@tyler-components-web/core';
import { StepComponent } from './step';
export * from './step-adapter';
export * from './step-constants';
export * from './step-foundation';
export * from './step';
export function defineStepComponent() {
    defineCustomElement(StepComponent);
}
